export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-11.6dea9b8b.jpg";